export class ServiceUrlConstants {
  public static readonly PATH_VAR_DOC_TYPE: string = '{doc_type}'
  public static readonly PATH_VAR_REFERENCE_TYPE: string = '{referenceType}'
  public static readonly VAR_REFERENCE_ID: string = 'referenceId'

  public static readonly API_LOGIN: string = '/login'
  public static readonly API_GENERATE_OTP_FOR_LOGIN = '/auth/login/otp/generate'
  public static readonly API_AUTH_LOGIN_FOR_DISCOVERY = '/auth/login/discovery'
  public static readonly API_OTP_BASED_LOGIN: string = '/login/otp'
  public static readonly API_OPTIONS: string = '/options'
  public static readonly API_SUMMARY_LIST = '/summary/list'
  public static readonly API_SESSION_REFRESH: string = '/token/refresh'
  public static readonly API_ACTVITY_DASHBOARD: string = '/module/ACTIVITY/dashboard'
  public static readonly API_SAVE_ACTIVITY: string = '/activity'
  public static readonly API_INITIALISE: string = '/initialise'
  public static readonly API_DOCUMENT: string = '/document/{doc_type}/reference/{referenceType}'
  public static readonly API_LOGOUT: string = '/logout'
  public static readonly API_SELECT_CLIENT: string = '/token/company/select'
  public static readonly HEADER_X_COMPANY_ENTITY_IDS = 'x-companyEntityIds'
  public static readonly HEADER_X_COMPANY_GROUP_ID = 'x-companyGroupId'
  public static readonly API_GET_COMPANY_NOTIFICATION_PREFERENCES: string = '/company/notificationPreferences'
  public static readonly API_SETTINGS: string = '/company/settings'

  public static readonly API_RESET_WITH_PASSWORD = '/password/reset/PASSWORD'
  public static readonly API_FORGOT_PASSWORD: string = '/password/forgot'

  public static readonly API_QUERIES_DASHBOARD: string = '/module/QUERIES/dashboard'
  public static readonly API_QUERY: string = '/queries'
  public static readonly API_UPDATE_QUERY: string = '/queries/'
  public static readonly PATH_VAR_TYPE_ID: string = '{typeId}'
  public static readonly PATH_VAR_TYPE: string = '{type}'
  public static readonly API_EXPORT_PDF: string = `/export/pdf/${ServiceUrlConstants.PATH_VAR_TYPE}/${ServiceUrlConstants.PATH_VAR_TYPE_ID}`
  public static readonly API_FETCH_QUERY_DETAILS: string = '/queries/'
  public static readonly API_SAVE_QUERY: string = '/queries'
  public static readonly API_QUERY_LIST: string = '/queries/list'
  public static readonly API_QUERY_SUMMARY_LIST = `${ServiceUrlConstants.API_QUERY}${ServiceUrlConstants.API_SUMMARY_LIST}`

  public static readonly API_SAVE_KNOWLEDGE: string = '/knowledgeArticle'
  public static readonly API_VIEW_KNOWLEDGE: string = '/knowledgeArticle/'
  public static readonly API_UPDATE_KNOWLEDGE_ARTICLE: string = '/knowledgeArticle/'

  public static readonly API_VIEW_KNOWLEDGE_SEARCH_LIST: string = '/knowledgeArticle/list'
  public static readonly API_PUBLISH_KNOWLEDGE_ARTICLE: string = '/knowledgeArticle/{0}/publish'

  public static readonly API_GOVERNMENT_BUSINESS_DASHBOARD: string = '/module/GOVERNMENT_BUSINESS/dashboard'
  public static readonly API_GOVERNMENT_BUSINESS_UPDATE: string = '/governmentBusiness/'
  public static readonly API_SAVE_GOVERNMENT_BUSINESS: string = '/governmentBusiness'
  public static readonly API_GOVERNMENT_BUSINESS_SUMMARY_LIST: string = '/governmentBusiness/list'
  public static readonly API_FETCH_GOVERNMENT_BUSINESS_DETAILS: string = '/governmentBusiness/'

  public static readonly API_EMPLOYEE_SUMMARY_LIST: string = '/employee/list'

  public static readonly API_ASSIGNEE_LIST: string = '/assignee/list'

  public static readonly API_EXPORT: string = '/export/'

  public static readonly API_DASHBOARD: string = '/dashboard'
  public static readonly API_ACTIVITY_SUMMARY_LIST = `${ServiceUrlConstants.API_SAVE_ACTIVITY}${ServiceUrlConstants.API_SUMMARY_LIST}`
  public static readonly API_UPDATE_PENDING = '/activity/status/bulk'
  public static readonly API_ACTIVITY_TYPE = '/ACTIVITY_TRACKER/types'
  public static readonly API_UPDATE_ACTIVITY: string = '/activity/'
  public static readonly API_FETCH_ACTIVITY_DETAILS: string = '/activity/'

  public static readonly API_DOWNLOAD_TEMPLATE: string = '/download/static/template/'
  public static readonly API_SAVE_BULK_ACTIVITY: string = '/activity/bulk/create'
  public static readonly API_SAVE_BULK_EMPLOYEE: string = '/employee/bulk/create'
  public static readonly API_UPDATE_BULK_EMPLOYEE: string = '/employee/bulk/update'
  public static readonly API_ANNOUNCEMENT_LIST: string = '/announcement/summary/list'
  public static readonly API_ANNOUNCEMENT_SAVE_UPDATE: string = '/announcement'
  public static readonly API_CALENDAR_LIST: string = '/calendarevents/list'
  public static readonly API_CALENDAR_SAVE_UPDATE: string = '/calendarevent'
  public static readonly API_SAVE_BULK_QUERY: string = '/query/bulk/create'
  public static readonly API_GOVERNMENT_BUSINESS_SUMMARY_LIST_EXPORT: string = `/governmentBusiness${ServiceUrlConstants.API_SUMMARY_LIST}${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_EMPLOYEE_SUMMARY_LIST_EXPORT: string = `/employee${ServiceUrlConstants.API_SUMMARY_LIST}${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_EMPLOYEE_SUMMARY_LIST_EXPORT_CSV_XLS: string = `/employeeReferenceDetails${ServiceUrlConstants.API_SUMMARY_LIST}${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_DOWNLOAD_DELETE_DOCUMENT: string = '/document/'
  public static readonly API_ANNOUNCEMENT_SUMMARY_LIST_EXPORT: string = `/announcement${ServiceUrlConstants.API_SUMMARY_LIST}/all${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_CALENDAR_SUMMARY_LIST_EXPORT: string = `/calendar${ServiceUrlConstants.API_SUMMARY_LIST}/all${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_KNOWLEDGE_SUMMARY_LIST_EXPORT: string = `/knowledgeArticle${ServiceUrlConstants.API_SUMMARY_LIST}${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_SSO_LOGIN: string = '/sso'
  public static readonly API_SAVE_BULK_CALENDAR_EVENT: string = '/calendarevents/bulk/create'
  public static readonly API_EMPLOYEE_SUMMARY_LIST_EXPORT_CSV_XLS_V2: string = `/v2/employeeReferenceDetails${ServiceUrlConstants.API_SUMMARY_LIST}${ServiceUrlConstants.API_EXPORT}`
  public static readonly API_REPORT: string = '/report'
  public static readonly API_REPORT_TYPE_ALL_QUERIES_COMPLIANCE_REPORT: string = '/ALL_QUERIES_COMPLIANCE_REPORT'
  public static readonly API_REPORT_TYPE_FEEDBACK_SUMMARY: string = '/FEEDBACK_SUMMARY'
  public static readonly API_UPDATE_REFERENCE_DETAILS: string = '/employee/{0}/reference-details/{1}'
  public static readonly API_EMPLOYEE_GENERATE_FORM11_READ_UPLOAD: string = '/employee/form11/read-and-upload'
  public static readonly API_UPLOAD_FORM11: string = '/uploadForm11Document/{activityId}'
  public static readonly PATH_VAR_TYPE_ACTIVITY_ID: string = '{activityId}'
  public static readonly API_DOWNLOAD_FORM11: string = '/employee/{0}/download/form11'
  public static readonly API_EMPLOYEE_REFERENCE_DETAILS: string = '/employee/{0}/reference-details'
  public static readonly API_REPORT_TYPE_NEW_JOINEE_WORKFLOW: string = '/NEW_JOINEE_WORKFLOW'
  public static readonly API_REPORT_TYPE_ACTIVITY_BOARD_OVERALL: string = '/ACTIVITY_BOARD_OVERALL'
  public static readonly API_REPORT_TYPE_GB_TASK_OVERALL: string = '/GB_TASK_OVERALL'
  public static readonly API_REPORT_TYPE_QUERY_OVERALL: string = '/QUERY_OVERALL'
  public static readonly API_OPTION: string = '/option'
  public static readonly API_SAVE_OFFLINE_TRACKER: string = '/offline-tracker'
  public static readonly API_FETCH_OFFLINE_TRACKER: string = '/offline-tracker/'
  public static readonly API_UPDATE_OFFLINE_TRACKER: string = '/offline-tracker/'
  public static readonly API_OFFLINE_TRACKER_SUMMARY_LIST: string = '/offline-tracker/summary/list'
  public static readonly API_ENTITY_WISE_DATA: string = '/dashboard/entity-wise-info'
  public static readonly API_UPDATE_BULK_QUERY: string = '/query/bulk/update'
  public static readonly API_QUERIES_DETAILS_ZIP: string = '/queries/details-zip'
  public static readonly API_SAVE_SCREEN_CONFIG: string = '/screen-configs'
  public static readonly API_GET_SCREEN_CONFIGS_BY_CONFIG_GROUP_ID: string = '/screen-configs/company-group'

  public static readonly API_ONBOARDING: string = '/onboarding'
  public static readonly API_ONBOARDING_SAVE_COMPANY = `${ServiceUrlConstants.API_ONBOARDING}/company`
  public static readonly API_ONBOARDING_SAVE_COMPANY_ENTITIES = `${ServiceUrlConstants.API_ONBOARDING}/company/entities`
  public static readonly API_ONBOARDING_SAVE_SOP_SETTINGS = `${ServiceUrlConstants.API_ONBOARDING}/sop-settings`
  public static readonly API_GET_UNASSIGNED_RMS_ADMINS = '/rms-admin/unassigned'
  public static readonly API_ONBOARDING_EMP_SEARCH = `${ServiceUrlConstants.API_ONBOARDING}/employee/search`
  public static readonly API_ONBOARDING_ASSIGN_EMPLOYEE_ADMINS = `${ServiceUrlConstants.API_ONBOARDING}/employee-admins`

  public static createUploadDocumentEndpoint(docType: string, referenceType: string, referenceId?: string) {
    return `${ServiceUrlConstants.API_DOCUMENT.replace(ServiceUrlConstants.PATH_VAR_DOC_TYPE, docType).replace(
      ServiceUrlConstants.PATH_VAR_REFERENCE_TYPE,
      referenceType
    )}${referenceId ? `?${ServiceUrlConstants.VAR_REFERENCE_ID}=${referenceId}` : ''}`
  }

  public static createDownloadExportPDFEndpoint(referenceType: string, referenceId: string) {
    return `${ServiceUrlConstants.API_EXPORT_PDF.replace(ServiceUrlConstants.PATH_VAR_TYPE, referenceType).replace(
      ServiceUrlConstants.PATH_VAR_TYPE_ID,
      referenceId
    )}`
  }

  public static createDocumentEndpoint(companyId: string, ownerId: string, name: string) {
    return `/document/${companyId}/${ownerId}/${name}`
  }

  public static createDownloadAllDocumentsEndpoint(referenceId: string) {
    return `/document/${referenceId}/all`
  }
}
